export enum MyProfileModeTypes{
    MyProfile = 'MyProfile',
    PmProfile = 'PmProfile',
    UserProfile = 'UserProfile'
}